import { AbstractControl, ValidationErrors } from '@angular/forms';

export function horasSoloDigitosValidator(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }

  const value = String(raw).trim();
  if (value === '') {
    return null;
  }

  return /^\d+$/.test(value) ? null : { horasSoloDigitos: true };
}
